import { useParams } from 'react-router-dom';
import SEO from '../components/SEO';
import BlogPost from '../components/BlogPost';
import { getBlogPostBySlug } from '../data/blogPosts';

export default function BlogPostPage() {
  const { slug } = useParams<{ slug: string }>();
  const post = slug ? getBlogPostBySlug(slug) : undefined;

  // Default SEO for non-existent posts (will redirect anyway)
  if (!post) {
    return (
      <>
        <SEO
          title="Blog Post Not Found | JsonToonCraft"
          description="The requested blog post could not be found."
          canonicalUrl="https://jsontooncraft.com/blog"
        />
        <BlogPost />
      </>
    );
  }

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": post.title,
    "description": post.description,
    "image": post.coverImage || "https://jsontooncraft.com/og-image.png",
    "datePublished": post.publishedAt,
    "dateModified": post.updatedAt || post.publishedAt,
    "author": {
      "@type": "Person",
      "name": post.author.name,
      "url": post.author.twitter ? `https://twitter.com/${post.author.twitter}` : undefined
    },
    "publisher": {
      "@type": "Organization",
      "name": "JsonToonCraft",
      "logo": {
        "@type": "ImageObject",
        "url": "https://jsontooncraft.com/og-image.png"
      }
    },
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://jsontooncraft.com/blog/${post.slug}`
    },
    "keywords": post.tags.join(', '),
    "wordCount": post.content.split(/\s+/).length,
    "timeRequired": `PT${post.readingTime}M`
  };

  return (
    <>
      <SEO
        title={`${post.title} | JsonToonCraft Blog`}
        description={post.description}
        keywords={post.tags.join(', ')}
        canonicalUrl={`https://jsontooncraft.com/blog/${post.slug}`}
        ogType="article"
        structuredData={structuredData}
      />
      <BlogPost />
    </>
  );
}
